module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACpSURBVHgB7VPRCYQwDE2OG6AjOMJtcN4GN4KbiJOIG+gEjqAbqBPoBvUFKtSaguCPHz54xCbxNaWvRBfB/sJaaxBy8B/pX8CCmWu1CoHM7pE7dl5udhupE5Ru914fgOTHD5hgikkSb6WpR/FH+oQpQuvnXnQRj8AdBDQfGNx3Euk3ZwTEaYP7Fs83YEkRhEeogvVIR1uPm40FHBTFrl+ElHTIa6wgsGyJFcZbSpc1/kALAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h1.png
// module id = cNT6
// module chunks = 1